/**
 * Observe la sidebar des formations
 * et vérifie que l'ensemble des contenus est bien visible dans le viewport
 *
 * Inspiration : https://stackoverflow.com/questions/16302483/event-to-detect-when-positionsticky-is-triggered
 */

import { Debounce } from './Helpers.js' ;

const headerBottom = document.querySelector('.wp-block-header__bottom');
const breadcrumb = document.querySelector('.wp-block-breadcrumb__container');
const sidebar = document.querySelector('.wp-block-sidebar__sticky');

const sidebarFormationsObserver = class sidebarFormationsObserver {

	constructor() {

		this.minimalScreenWidth = 1280 ;

		this.setValues() ;
		this.observeStickyPosition() ;
		this.observeSidebarSize() ;
		this.refreshOnresize() ;
	}

	/**
	 * La marge de déclenchement de l'intersection doit être adaptée à la hauteur de l'en-tête et à l'espacement vertical
	 * On définit une valeur supérieure pour forcer le déclenchement
	 */
	setValues(){

		let headerBottomHeightValue = parseInt(window.getComputedStyle(headerBottom).height, 10) ;
		if( isNaN(headerBottomHeightValue) ){
			headerBottomHeightValue = 0 ;
		}
		this.headerBottomHeight = headerBottomHeightValue ;

		this.breadcrumbHeight   = parseInt(window.getComputedStyle(breadcrumb).height, 10) ;
		this.sidebarPaddingTop  = parseInt(window.getComputedStyle(sidebar).paddingTop, 10) ;

		this.observerMarginTop = -1 * ( this.headerBottomHeight + this.breadcrumbHeight + this.sidebarPaddingTop + 1 ) ;

		this.setScrollMarginTop() ;
	}


	/**
	 * Définir la marge de défilement en fonction de la hauteur de l'en-tête
	 */
	setScrollMarginTop(){
		// console.log(this.headerBottomHeight);
		// document.body.style.setProperty('--js-observer-header--scroll-margin-top', this.headerBottomHeight + 'px' ) ;
		document.body.style.setProperty('--js-observer-header--scroll-margin-top', 134 + 'px' ) ;
	}


	/**
	 * Observer la sidebar des formations
	 */
	observeStickyPosition(){

		this.positionObserver = new IntersectionObserver(
			( [e] ) => {

				const forceSticky = e.intersectionRatio < 1 ;
				e.target.classList.toggle('js-observed--sticky', forceSticky );
				this.refreshCSSTransformations( e.target, forceSticky );

			}, {
				rootMargin:  this.observerMarginTop + 'px 0px 0px 0px',
				threshold: [1]
			}
		);

		this.positionObserver.observe(sidebar) ;
	}


	/**
	 * Vérifier si la sidebar est sticky
	 * d'après l'existence de la classe js-observed--sticky
	 * @returns {boolean}
	 */
	isSidebarSticky(){

		const sidebarClasses = sidebar.classList ;
		return sidebarClasses.contains('js-observed--sticky') ;
	}


	/**
	 * Observer la taille de la sidebar
	 * et lance une vérification de la taille de la sidebar (avec un debounce)
	 */
	observeSidebarSize(){

		const debouncedSidebarSizeCheck = Debounce( ( entries ) => {
			this.handleSidebarOverflow(entries) ;
		}, 250 ) ;

		this.sizeObserver = new ResizeObserver(
			( entries ) => {
				debouncedSidebarSizeCheck(entries) ;
			}
		);

		this.sizeObserver.observe(sidebar) ;
	}


	/**
	 * Rafraîchir les valeurs en cas de redimensionnement de la fenêtre
	 */
	refreshOnresize(){

		const debouncedSetValues = Debounce( () => {
			this.setValues() ;
		}, 250 ) ;

		window.addEventListener('resize', debouncedSetValues ) ;
	}


	/**
	 * Check if the sidebar is too big for the viewport :
	 * (!) if the sidebar is too big, the sticky behavior is disabled
	 */
	handleSidebarOverflow( ResizeObserverEntries = [] ){

		console.log('handleSidebarOverflow');

		const isSidebarSticky = this.isSidebarSticky() ;
		if( ! isSidebarSticky ){ return ; }

		// map on ResizeObserverEntries
		ResizeObserverEntries.map( ( entry ) => {

			const { target, contentRect } = entry ;

			if( ! target.classList.contains('wp-block-sidebar__sticky') ){ return false ; }

			const sidebarHeight = contentRect.height ;
			const sidebarTop = target.getBoundingClientRect().top ;
			target.classList.toggle('js-defined--static', ( sidebarHeight + sidebarTop ) >= window.innerHeight ) ;

			// Scroller si une ville est ouverte && que la sidebar est trop grande
			// marge de rab : 80
			if( ( sidebarHeight + sidebarTop + 160 ) >= window.innerHeight ){

				const cityActive = document.querySelector('.wp-block-city.active') ;

				if( ! cityActive ){ return false ; }

				this.setScrollMarginTop()
				location.hash = "#" + cityActive.id;
			}

			return true ;
		});

	}


	/**
	 * Rafraîchir les transformations CSS (prévu pour la sidebar)
	 * @param {HTMLElement} element
	 * @param {boolean} stickyState
	 */
	refreshCSSTransformations( element = null, stickyState = false ){
		if( ! element ){ return ; }

		const sidebarClasses = sidebar.classList ;
		if( ! stickyState ){
			sidebarClasses.remove('js-defined--static' ) ;
		}
	}

}

export { sidebarFormationsObserver }